import { Injectable } from "@angular/core";

interface BackPoint {
  scrollY?: number;
  coinId?: string | number;
}

@Injectable({ providedIn: "root" })
export class PageStateService {
  private backPoints = new Map<string, BackPoint>();

  setBackPoint(key: string, point: BackPoint) {
    this.backPoints.set(key, { ...point });
  }

  consumeBackPoint(key: string): BackPoint | null {
    const v = this.backPoints.get(key) || null;
    if (v) this.backPoints.delete(key);
    return v;
  }

  clear(key: string) {
    this.backPoints.delete(key);
  }

  has(key: string): boolean {
    return this.backPoints.has(key);
  }
}
